'use strict';

window.addEventListener('DOMContentLoaded', function () {
  // tempSpecialNavButton[data-view]を取得
  const tempSpecialNavButton = document.querySelectorAll(
    '.tempSpecialNavButton'
  ) as NodeListOf<HTMLElement>;
  // tempSpecialArticleListを取得
  const tempSpecialArticleList = document.querySelectorAll(
    '.tempSpecialArticleList'
  ) as NodeListOf<HTMLElement>;

  //クリックイベント
  tempSpecialNavButton.forEach((button) => {
    button.addEventListener('click', () => {
      // tempSpecialNavButton[data-item]のdata-itemを取得
      const item = (button as HTMLElement).dataset.item;
      tempSpecialNavButton.forEach((el) => {
        el.dataset.view = 'false';
      });
      button.dataset.view = 'true';

      // tempSpecialArticleListをforEachで回す
      tempSpecialArticleList.forEach((article) => {
        // display:noneを付与
        article.style.display = 'none';
        // tempSpecialArticleList[data-item]のdata-itemを取得
        const target = article.dataset.item;
        // itemとtargetが一致したらdisplay:blockを付与
        if (item === target) {
          article.style.display = 'grid';
        }
      });
    });
  });

  // tempSpecialArticleListの中にあるtempSpecialArticleを取得
  tempSpecialArticleList.forEach((article) => {
    const tempSpecialArticle = article.querySelectorAll('.tempSpecialArticle');
    if (tempSpecialArticle.length === 0) {
      // articleのdata-itemを取得
      const item = article.dataset.item;
      // .tempSpecialNavButtonの上記で取得したdata-itemと一致するものを取得
      const button = document.querySelector(
        `.tempSpecialNavButton[data-item="${item}"]`
      );
      // buttonの親要素を取得し、display:noneを付与
      if (button && button.parentElement) {
        button.parentElement.style.display = 'none';
      }
      article.style.display = 'none';
    }
  });
});
